import React, { useEffect, useState } from 'react';

import './Preview.billEvents.scss';
import { BaseReact } from '../../base.model';
import { ProfileQL } from '../../models/Profile';
import SectionTitleBar from '../components/titlebar';
import { ToBillArguments, ToBillEvent } from '../../models/Factura';

import { useMutation } from '@apollo/react-hooks';
import { graphqlSchema } from '../../services/graphql.schema';
import sharedToasterSubject from '../../services/shared.toasterSubject';
import { parseStampErrorFromGraphQL } from '../../utils/error.graphql';
import { clearGqlTypename } from '../../utils/formatting';
import BillEventsMainBill from './billEvents/BillEvents.mainBill';
import BillEventsSecondaryBills from './billEvents/BillEvents.secondaryBills';
import PreviewActions from './components/Preview.actions';
import { normalizeBillEventsForStamping } from './handlers/billEvents.normalize';

interface PreviewProps extends BaseReact {
    currentUser: ProfileQL;
}

function PreviewBillEventFactura({ currentUser, location, history }: PreviewProps) {
    console.log('[FP] Location: ', location);
    const [toBillArgument, setToBillArgument] = useState<ToBillArguments<ToBillEvent>>(null);
    const [toBillEvents, setToBillEvents] = useState<ToBillEvent[]>(null);

    // UI Elements
    const [paymentError, setPaymentError] = useState('');
    const [stamping, setStamping] = useState(false);
    // ============
    useEffect(() => {
        // Extract state and use for current operations
        const { billArgument, billEvents } = location.state as { billArgument: ToBillArguments<ToBillEvent>; billEvents: ToBillEvent[]; };
        setToBillArgument(clearGqlTypename(billArgument));
        setToBillEvents(billEvents.map(e => clearGqlTypename(e)));
    }, [location]);

    const [billEventForStamping] = useMutation(graphqlSchema.FISCALPOP.CFDI.stampFromBillEvent, {
        onCompleted: ({ stampFromBillEvent }: { stampFromBillEvent: ToBillArguments<string> }) => {
            console.log('STAMP FROM BILL ARGUMENT: ', stampFromBillEvent);
            sharedToasterSubject.next({ type: 'confirm', message: 'Factura emitida correctamente' });
            history.push({
                pathname: '/',
                state: { billArgument: stampFromBillEvent }
            })
        },
        onError: (e) => {
            console.error('Error Saving GQL RAW: ', e);
            console.error('Error Saving GQL: ', e.graphQLErrors[0]);
            sharedToasterSubject.next({ type: 'error', message: parseStampErrorFromGraphQL(e.graphQLErrors[0]), clearTs: 5200, clickToClose: true });
            setPaymentError(parseStampErrorFromGraphQL(e.graphQLErrors[0]))
            setStamping(false);
        }
    })

    const submitArgument = () => {
        setStamping(true);
        const stringToBillArgs: any = toBillArgument;
        stringToBillArgs.billEvents = stringToBillArgs.billEvents.map((e: ToBillEvent) => e._id);
        billEventForStamping({
            variables: {
                argument: stringToBillArgs,
                cfdi: normalizeBillEventsForStamping(toBillEvents, toBillArgument, currentUser.fiscalpopProfile),
            }
        })
    }

    const returnToModify = () => {
        history.goBack();
    }

    const handleNotaCreditoEdit = (property: 'serie' | 'folio') => {
        return (value: string) => {
            const aggr: { [key: string]: string } = {}
            aggr[property] = value;
            const _billEvent = Object.assign({}, toBillEvents[0]);
            _billEvent.NotaCreditoCFDI = Object.assign({}, _billEvent.NotaCreditoCFDI, aggr)
            setToBillEvents([_billEvent]);
        }
    }

    const handleCfdiEdit = (property: 'serie' | 'folio') => {
        return (value: string) => {
            const aggr: { [key: string]: string } = {}
            aggr[property] = value;
            const _billEvent = Object.assign({}, toBillEvents[0]);
            _billEvent.CFDI = Object.assign({}, _billEvent.CFDI, aggr)
            setToBillEvents([_billEvent]);
        }
    }

    return (
        <div id="FacturaBillPreview">
            <SectionTitleBar currentUser={currentUser} title="Previsualizar Factura" />
            <div className="previewContent">
                <BillEventsMainBill toBillArgument={toBillArgument} />
                <BillEventsSecondaryBills
                    toBillEvents={toBillEvents}
                    onNotaCreditoEdit={handleNotaCreditoEdit}
                    onCfdiEdit={handleCfdiEdit}
                />
                <PreviewActions
                    error={paymentError || null}
                    stamping={stamping}
                    onReturn={returnToModify}
                    onSubmit={submitArgument}
                />
            </div>
        </div>
    )
}

export default PreviewBillEventFactura;
